'use client';

import { FloatingWidget } from '@/app/contact/components/floating-widget';
import { CalComInit } from '../cal-com-init';
import { FloatingVoiceAgent } from '../voice/FloatingVoiceAgent';

export function DeferredWidgets({ displayName }: { displayName?: string }) {
  return (
    <>
      <FloatingVoiceAgent displayName={displayName} />
      <FloatingWidget />
      <CalComInit />
    </>
  );
}
